/**
 * Chat-Identität: Initialen + stabile Avatar-Farbe pro Autor*in, damit
 * Nutzerprofile im Chat wiedererkennbar sind (ohne echte Profilbilder).
 */

const AVATAR_COLORS = [
  "#8c4a2f",
  "#7a1f1f",
  "#274536",
  "#1f3a5f",
  "#5b2d5e",
  "#2d5f4a",
  "#44337a",
  "#6b3a10",
] as const;

export interface ChatIdentity {
  initials: string;
  color: string;
}

const seed = (value: string) =>
  [...value].reduce(
    (acc, character) => acc + character.codePointAt(0)! * 31,
    0,
  );

export const chatIdentity = (
  authorName: string,
  authorUserId: string | null | undefined,
): ChatIdentity => {
  const clean = (authorName || "?").replace(/[\s\-.]+/g, " ").trim();
  const words = clean.split(" ").filter((word) => word.length > 0);
  const first = words[0] ?? clean;
  const second = words[1] ?? "";
  const raw =
    words.length > 1 ? first.charAt(0) + second.charAt(0) : clean.slice(0, 2);
  const hash = seed(authorUserId || authorName || "?");
  return {
    initials: (raw || "?").toUpperCase(),
    color: AVATAR_COLORS[hash % AVATAR_COLORS.length] ?? AVATAR_COLORS[0]!,
  };
};
